<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 营养门诊-患者基础信息
-->

<template>
  <div class="nutritionalScreeAssessResult-page">
    <div class="content">
      <div class="title">{{formData?.riskDescription  }}</div>
      <div class="suggestion">
        {{ formData?.riskAdvice }}
      </div>

      <div class="ill-history">
        <div class="title">既往病史</div>
        <div class="text">
         <!-- healthZpCjbszzs -->
          {{ formData?.healthZpJtqzjbName }}
          <!-- 高血脂 -->
        </div>
      </div>
      <div class="ill-history">
        <div class="title">容易引起</div>
        <div class="text highlight">
          {{ formData?.healthZpJtqzjbCauseOtherComplication }}
        </div>
      </div>
    </div>

        <div class="next-btn-wrapper">
          <van-button round block color="#FBB13D" plain @click="$emit('prev-step')">上一页</van-button>
          <van-button round block color="#FBB13D" type="info" @click="onSubmit">继续答题</van-button>
        </div>
  </div>
</template>

<script>
// import {getQueryString} from '../utils/utils'
export default {
  name: 'NutritionalScreenAssessResult',
  props:{
    id:String,
    doctorId:String,
  initData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formData:{}
    }
  },
  created() {
  },
  mounted() {
    if(this.initData){
      this.formData = {...this.initData.screenAssessment,...this.initData}
    }
  },
  methods: {
    onSubmit() {
      // this.$emit('next-step', { type: '' })
      this.$router.push({
        path: '/clinic/listStyle',
        query: {
          id: this.id,
          doctorId: this.doctorId,
        }
      })
    }
  }
};
</script>

<style scoped>
div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.nutritionalScreeAssessResult-page {
  width: 100%;
  height: 100vh;
  padding: 1.33rem;
  background: #F6F7F8;
}

.content {
  width: 100%;
  height: auto;
  padding: 2rem 1.33rem;
  border-radius: 0.92rem;
  background-color: #fff;
}

.content>.title {
  font-weight: 500;
  font-size: 1.67rem;
  color: #333333;
  line-height: 2.33rem;
  margin-bottom: 2rem;
  text-align: center;
}

.content .suggestion {
  padding: 1rem;
  height: auto;
  font-weight: 500;
  font-size: 1.33rem;
  color: #FBB13D;
  background-color: rgba(251, 177, 61, 0.2);
  line-height: 1.83rem;
  margin-bottom: 2rem;
}

.ill-history {
  position: relative;
  padding-left: 1rem;
  margin-bottom: 2rem;

}

.ill-history::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.92rem;
  transform: translateY(-50%);
  width: 0.33rem;
  height: 0.33rem;
  border-radius: 50%;
  background-color: #FBB13D;
}

.ill-history .title {
  height: 1.83rem;
  font-size: 1.33rem;
  color: #333333;
  line-height: 1.83rem;
  margin-bottom: 0.67rem;
}

.ill-history .text {
  font-size: 1.33rem;
  color: #999999;
  line-height: 1.83rem;
}

.ill-history .text.highlight {
  font-weight: 500;
  color: #FBB13D;
}
.next-btn-wrapper {
  width: 100%;
  height: 6.9rem;
  display: flex;
  gap: 1.42rem;
  background-color: #fff;
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  padding: 0.33rem 2rem;
  box-shadow: inset 0rem 0.04rem 0rem 0rem rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
}
</style>
